import React          from 'react';
import { Link }       from 'react-router-dom';
import * as PropTypes from 'prop-types';

const SearchNewsItem = function(props) {
  const {
          announce,
          createdAt,
          label,
          previewImage,
          urlKey
        } = props;

  return (
    <Link
      to={urlKey}
      className={'item new inline'}
    >
      <picture className={'picture'}>
        <source srcSet={`${previewImage}.webp`} type={'image/webp'} />
        <img src={`${previewImage}.png`} alt={label} />
      </picture>
      <div>
        <div className={'title'}>{label}</div>
        <div className={'date'}>{createdAt}</div>
        {typeof announce === 'string' && (
          <div className={'description'} dangerouslySetInnerHTML={{__html: announce}} />
        )}
      </div>
    </Link>
  );
};

SearchNewsItem.propTypes = {
  announce:     PropTypes.string,
  createdAt:    PropTypes.string.isRequired,
  previewImage: PropTypes.string.isRequired,
  label:        PropTypes.string.isRequired,
  urlKey:       PropTypes.string.isRequired
};

export default SearchNewsItem;